import { DeviationPageState } from './types';

export const reduxKey = '@@devpage';
export const actionKey = '@@devpage';

export const defaultState: DeviationPageState = {
  viewOptions: {
    activeActionBar: 'primary',
  },
};
